import axios from 'axios';

const axiosMuiltipartConfig = axios.create({
	baseURL: import.meta.env.API_URL,
	headers: {
		'Content-Type': 'multipart/form-data'
	}
});
axiosMuiltipartConfig.defaults.withCredentials = true;

export default axiosMuiltipartConfig;
